module.exports = __webpack_public_path__ + "img/02.b02a554f.png";